module.exports = __webpack_public_path__ + "img/train.3bcbd9ac.jpg";